define('webshopProductsDetailBodyProductView',[
  'module',
  'headerFooterView',
  'webshopProductsDetailBodyProductBodyView',
  'webshopProductsDetailBodyProductFooterView'
], function (
  Module,
  HeaderFooterView,
  BodyView,
  FooterView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    childView: BodyView,
    childFooterView: FooterView
  });
});
